// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const financeClient = createTypedClient();
export const createFinanceClient = (config) => createTypedClient(config);
